import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from 'swiper';
import '../style.scss'
import { Container, Tabs, Tab } from 'react-bootstrap'
import HomeMainTitle from '../../../homeTitle/HomeMainTitle';
import { Link } from 'react-router-dom';
import default_image_url from '../../../../redux/api/API';
import { useTranslation } from 'react-i18next';
SwiperCore.use([Pagination]);

const CompanyProducts = ({data}) => {
  const {t} = useTranslation();
  const lang = localStorage.getItem('lang')

  if(data) {
      return (
        <>
        {data.length ?
        <Container>
          <div className='col-12 mb-5 py-5'>
            <HomeMainTitle>{t("dashboard_nav_products_category")}</HomeMainTitle>
            <Tabs defaultActiveKey="all" id="products">
              <Tab eventKey="all" title="همه محصولات" className='products_tab'>
                <div className='company-products'>
                    <Swiper 
                        spaceBetween={10} 
                        pagination={{ "clickable": true }}
                        breakpoints={{
                          640: {
                            width: 640,
                            slidesPerView: 1,
                          },
                          900: {
                            width: 900,
                            slidesPerView: 2,
                          },
                          990: {
                            width: 990,
                            slidesPerView: 4,
                          },
                        }}
                        className="productsSwiper">
                      {data.map(item => item.products.map(product => (
                        <SwiperSlide key={product.id}>
                          <div key={product.id} className='px-2'>
                            <Link to={`/product/${product.id}`} className='company-product'>
                              {product.photos.length ? 
                                product.photos.filter(picture => picture.type === "main").map(picture => 
                                  <img key={picture.id} src={default_image_url+picture.small_path} alt="product" />    
                                )
                              :
                                <img src="/assets/img/placeholder-image.png" alt="product" />
                              }
                                <h1>{product.name}</h1>
                                <span>{product.brand}</span>
                                <div className='company-product-footer'>
                                {product.price !== product.sell_price ?
                                  <>
                                    <span className='price'>{parseInt(product.price).toLocaleString()}</span>
                                    <span className='sell_price'>{parseInt(product.sell_price).toLocaleString()} {lang === 'en' ? 'Rial' : " ریال"}</span>
                                  </>
                                :
                                  <span className='sell_price'>{parseInt(product.sell_price).toLocaleString()} {lang === 'en' ? 'Rial' : " ریال"}</span>
                                }
                                </div>
                            </Link>
                          </div>
                        </SwiperSlide>
                      )))}
                      </Swiper>
                  </div>
              </Tab>
              {data.map(item => (
                <Tab key={item.id} eventKey={item.name} title={item.name} className='products_tab'>
                  <div className='company-products'>
                    <Swiper 
                        spaceBetween={10} 
                        pagination={{ "clickable": true }}
                        breakpoints={{
                          640: {
                            width: 640,
                            slidesPerView: 1,
                          },
                          900: {
                            width: 900,
                            slidesPerView: 2,
                          },
                          990: {
                            width: 990,
                            slidesPerView: 4,
                          },
                        }}
                        className="productsSwiper">
                      {item.products.map(product => (
                        <SwiperSlide key={product.id}>
                          <div key={product.id} className='px-2'>
                            <Link to={`/product/${product.id}`} className='company-product'>
                              {product.photos.length ? 
                                product.photos.filter(picture => picture.type === "main").map(picture => 
                                  <img key={picture.id} src={default_image_url+picture.small_path} alt="product" />    
                                )
                              :
                                <img src="/assets/img/placeholder-image.png" alt="product" />
                              }
                                <h1>{product.name}</h1>
                                <span>{product.brand}</span>
                                <div className='company-product-footer'>
                                  {product.price !== product.sell_price ?
                                    <>
                                      <span className='price'>{parseInt(product.price).toLocaleString()}</span>
                                      <span className='sell_price'>{parseInt(product.sell_price).toLocaleString()} ریال</span>
                                    </>
                                  :
                                    <span className='price'>{parseInt(product.price).toLocaleString()}</span>
                                  }
                                </div>
                            </Link>
                          </div>
                        </SwiperSlide>
                      ))}
                      </Swiper>
                  </div>
                </Tab>
              ))}
            </Tabs>
        </div>
      </Container>
      :
        ''
      }
      </>
    )
    } else {
      return (<></>)
    }
}

export default CompanyProducts
